import { uncapitalize } from '@attain-apps/string-utils'

import * as core from '../../../../../../core'
import * as common from '../../../../../common'

import * as sponsorType from './sponsor-type'

// NOTE: everything below is designed to simulate a normal folder/module
// structure for exporting resources from separate files. This just simply
// generates those resources based on the known enum entries

const enumId = core.dms.models.Enum.Id.from({
  partialId: sponsorType.RESOURCE.payload.partialId,
})

const enumEntryResourceNameLookup = {} as Record<common.SponsorType, string>
for (const enumEntryName in common.SponsorType) {
  const potentialEnum =
    common.SponsorType[enumEntryName as keyof typeof common.SponsorType]
  if (common.SponsorType.isSponsorType(potentialEnum)) {
    enumEntryResourceNameLookup[potentialEnum] = uncapitalize(enumEntryName)
  }
}

export const entries = common.SponsorType.ALL.reduce(
  (prev, _sponsorType) =>
    Object.assign(prev, {
      [enumEntryResourceNameLookup[_sponsorType]]: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        RESOURCE: {
          payload: {
            ...common.SponsorType.getEntry(_sponsorType),
            enumId,
          },
          type: core.quiver.Resource.Type.DmsEnumEntry,
        } as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>,
      },
    }),
  {} as {
    [K in keyof typeof common.SponsorType as (typeof common.SponsorType)[K] extends common.SponsorType
      ? Uncapitalize<K>
      : never]: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      RESOURCE: core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
    }
  },
)
